<template>
    <section class="section home">
        
        <div class="light">
            <svg :style="{
                width: '25px',
                height: '84px',
                marginTop: i == 1 || i == 5 ? '-23px' : 
                    i == 3 || i == 7 ? '-32px' : 
                    i == 2 || i == 6 ? '-11px' : ''
            }" v-for="i in 8">
                <rect x="12" y="0" width="2" height="80" fill="#7992F9" />
                <circle cx="12.5" cy="80" r="4" fill="#F2B20E" />
                <path d="M0 80 A 12.5 12.5 0 0 1 25 80" fill="#7992F9" />
            </svg>
            <!-- <img src="@/assets/img/decals/light.svg" alt=""> -->
        </div>
        <div class="home-header">
            <div class="home-header-col">
                <p class="home__subtitle">Сегодня {{ current_day }}, {{ current_date }}</p>
            </div>
        </div>
        <div class="home-body">
            <div class="row">
                <div class="col">
                    <dashboardMetriks v-if="dashboardData && dashboardData.main_metrics" :data="dashboardData.main_metrics"/>
                </div>
                <div class="col" >
                    <dashboardPayments v-if="dashboardData && dashboardData.payment_types" :data="dashboardData.payment_types"/>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <dashboardHoursRevenue v-if="dashboardData && dashboardData.revenue_by_hours" :data="dashboardData.revenue_by_hours"/>
                </div>
                <div class="col">
                    <dashboardWaiters v-if="dashboardData && dashboardData.waiters" :data="dashboardData.waiters"/>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <dashboardTopClients v-if="dashboardData && dashboardData.top_clients" :data="dashboardData.top_clients"/>
                </div>
                <div class="col">
                    <dashboardProducts v-if="dashboardData && dashboardData.top_products" :data="dashboardData.top_products"/>
                </div>
            </div>
        </div>
    </section>
    <NameEditModal />
</template>

<script>
import axios from 'axios';
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import dashboardNews from "@/components/dashboard/dashboardNews.vue";
import dashboardTasks from "@/components/dashboard/dashboardTasks.vue";
import dashboardMetriks from "@/components/dashboard/dashboardMetriks.vue";
import dashboardPayments from "@/components/dashboard/dashboardPayments.vue";
import dashboardHoursRevenue from "@/components/dashboard/dashboardHoursRevenue.vue";
import dashboardWaiters from "@/components/dashboard/dashboardWaiters.vue";
import dashboardTopClients from "@/components/dashboard/dashboardTopClients.vue";
import dashboardProducts from "@/components/dashboard/dashboardProducts.vue";
import NameEditModal from "@/components/modals/NameEditModal.vue";

export default {
    name: "HomeView",

    data() {
        return {
            task_select: "неделя",
            current_date: "",
            current_day: "",
            current_time: "",
            user_search: '',
            dashboardData: null
        };
    },

    components: {
        dashboardNews,
        dashboardTasks,
        dashboardMetriks,
        dashboardPayments,
        dashboardHoursRevenue,
        dashboardWaiters,
        dashboardTopClients,
        dashboardProducts,
        NameEditModal
    },

    computed: {
        ...mapState({
            notifications: (state) => state.home.notifications,
            user_permissions: (state) => state.user_permissions,
        }),

        ...mapGetters({
            getUserPermissions: 'getUserPermissions'
        })
    },

    methods: {
        ...mapMutations({
            setGlobalLoading: 'setGlobalLoading'
        }),

        ...mapActions({
            getShop: "home/getShop",
        }),

        getCurrentDate() {
            let date = new Date();
            let monthNames = [
                "января",
                "февраля",
                "марта",
                "апреля",
                "мая",
                "июня",
                "июля",
                "августа",
                "сентября",
                "октября",
                "ноября",
                "декабря",
            ];
            let dayNames = ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"];
            let day = date.getUTCDate();
            let month = monthNames[date.getUTCMonth()];
            let year = date.getUTCFullYear();

            this.current_date = day + " " + month + " " + year;
            this.current_day = dayNames[new Date().getDay()];
        },

        async fetchDashboardData() {
            this.setGlobalLoading(true)
            return axios
                .get(`https://backend.tcode.online/api/dashboard/charts/tcode/main-v2/`, {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.dashboardData = response.data
                    }
                    this.setGlobalLoading(false)
                })
                .catch((error) => {
                    console.log(error.response);
                    this.setGlobalLoading(false)
                });
        }
    },

    mounted() {
        this.getCurrentDate()
        this.fetchDashboardData()
    },
};
</script>
<style scoped lang="sass">
.col-2
    grid-column: span 1
    max-width: 100%
    overflow: clip

.light
    position: absolute
    top: 0
    right: 100px
    display: flex
    gap: 15px
    z-index: -1
    @media only screen and (max-width: 1024px)
        top: -60px
        right: -200px
    @media only screen and (max-width: 425px)
        top: -55px
        right: -400px
    & img
        @media only screen and (max-width: 1024px)
            width: 80%
        @media only screen and (max-width: 425px)
            width: 70%
</style>
